import React, { useEffect, useRef, useState } from 'react';
import styles from './TraderCard.module.css';

const Banner = ({ bannerUrl, setBannerUrl, setBannerFile }) => {
    const fileInputRef = useRef(null);
    const [validFile, setvalidFile] = useState(true);

    useEffect(() => {
        if (!bannerUrl) {
            setvalidFile(false);
        } else {
            const img = new Image();
            img.src = bannerUrl;
            img.onload = () => setvalidFile(true);
            img.onerror = () => setvalidFile(false);
        }
    }, [bannerUrl])

    function handleRemove() {
        setBannerUrl(null);
        setBannerFile(null);
    }

    function handleUpload() {
        fileInputRef.current?.click();
    }

    function handleFile(e) {
        e.preventDefault();
        const file = e.target.files?.[0];
        if (!file) return;
        const previewUrl = URL.createObjectURL(file);
        setBannerFile(file);
        setBannerUrl(previewUrl);
    }

    return (
        <div className={styles.banner} style={{ backgroundImage: `url(${!validFile ? '/TraderCard/defaultBanner.jpg' : bannerUrl})` }}>
            <div className={styles.filter} id={!validFile ? styles.default : undefined}>
                <button type='button' onClick={() => handleUpload()} className={styles.bannerBtn}>Télécharger une bannière</button>
                <button type='button' onClick={() => handleRemove()} className={styles.bannerBtn}>Supprimer la bannière</button>
                <input ref={fileInputRef} onChange={handleFile} type="file" accept="image/*" style={{ display: 'none' }} />
            </div>
        </div>
    );
};

export default Banner;